import React, { Component } from 'react';
import * as moment from "moment";
import './SplashScreen.css';

class SplashScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      x: 0,
      video_duration: "Duration Unknown",
      splash_imgs: null
    };
  }

  componentDidUpdate() {
    // set video duration
    if (this.state.video_duration === "Duration Unknown") {
      let duration = "";
      if (this.props.data &&
          this.props.data.recording.info &&
          this.props.data.recording.info.movie_exported_duration ) {

        let seconds = parseFloat(this.props.data.recording.info.movie_exported_duration);
        duration = moment.utc(seconds*1000).format('HH:mm:ss'); //string
        let moment_dur = moment(duration, "hh:mm:ss"); // moment object

        duration = "";
        let hour = moment_dur.hours();
        let minute = moment_dur.minutes();
        let sec = moment_dur.seconds();
        if (hour) {
          duration += (hour === 1) ? (hour + " hour ") : (hour + " hours ");
          if (minute) {
            duration += (minute === 1) ? (minute + " minute ") : (minute + " minutes ");
          }
        }
        else if (!hour && minute) {
          duration += (minute === 1) ? (minute + " minute ") : (minute + " minutes ");
          if (sec) {
            duration += (sec === 1) ? (sec + " second ") : (sec + " seconds ");
          }
        }
        else if (!hour && !minute && sec) {
          duration += (sec === 1) ? (sec + " second ") : (sec + " seconds ");
        }
        else {
          duration = "[Duration Unknown]";
        }

        this.setState({
          video_duration: duration,
        });
      }
    }

    // set splashscreen image stack
    if (this.state.splash_imgs === null) {
      let imgs = [];
      if (this.props.data && this.props.data.recording &&
          this.props.data.recording.info && this.props.data.recording.info.thumbnails) {
        let img_string = this.props.data.recording.mediaPrefix +
                        this.props.data.recording.sitekey + "/" +
                        this.props.data.recording.info.thumbnails_folder + "/";
        let thumbnails_length = this.props.data.recording.info.thumbnails.length;

        // if no thumbnail available
        if (thumbnails_length === 0) {
          alert("zero thumbnails available!");
        }
        // thumbnails.length between 1-10 inclusive
        else if (thumbnails_length >= 1 && thumbnails_length <= 10) {
          for (let i = 0; i < thumbnails_length; ++i) {
            imgs.push(img_string +
              this.props.data.recording.info.thumbnails[i][0].toString() +
              ".jpg");
          }
        }
        // thumbnails >= 10
        else {
          // push first thumbnail
          imgs.push(img_string +
            this.props.data.recording.info.thumbnails[0][0].toString() +
            ".jpg");
          // push in 8 spaced out thumbnails
          let increment = Math.floor((thumbnails_length - 2) / 8);
          let start = 1;
          for (let i = 0; i < 8; ++i) {
            imgs.push(img_string +
              this.props.data.recording.info.thumbnails[start][0].toString() +
              ".jpg");
            start += increment;
          }
          // push last thumbnail
          imgs.push(img_string +
            this.props.data.recording.info.thumbnails[thumbnails_length-1][0].toString() +
            ".jpg");
        }
        this.setState({
          splash_imgs: imgs
        });
      }
    }
  }

  setHtml = (text) => {
    return { __html: text.replace(/(?:\r\n|\r|\n)/g, "<br />") };
  }

  // set x pixel when hovering over stack of images
  _onMouseMove(e) {
    this.setState({ x: e.nativeEvent.offsetX});
  }

	render() {
    const x = this.state.x;
    let imgs = [];
    let partition = 0;
    if (this.state.splash_imgs) {
      imgs = this.state.splash_imgs;
      partition = 320 / imgs.length;
    }

    return (
      <div className="splashscreen">
        <div className="splashscreen-overlay">
          <div className="splashscreen-inner">
            { this.props.data.recording.title ?
              (<p className="splashscreen-title" dangerouslySetInnerHTML={this.setHtml(this.props.data.recording.title)}></p>)
              :
              (<p className="splashscreen-title">
                [Untitled Recording]
              </p>)
            }

            {imgs.length === 0 ? null :
              (
                <div onMouseMove={this._onMouseMove.bind(this)} className="splashscreen-slide-preview-container">
                  {imgs.map((imag, i) => {
                    return (
                      <img className={ x >= (i*partition) &&
                                       x < ((i+1)*partition) ?
                                       "splashscreen-img-front" :
                                       "splashscreen-img"}
                        src={imag}
                        key={"splash-image"+i}
                        alt={"splash-image"+i}
                      />
                    );
                  })}
                </div>
              )
            }

            <div className={imgs.length !== 0 ? "splash-align-right" : ""} >
              { this.props.data.recording.description &&
                <p className="splashscreen-description" dangerouslySetInnerHTML={this.setHtml(this.props.data.recording.description)}></p>
              }
              <div className="splashscreen-metadata">
                { this.props.data.recording.date &&
                  <p>
                    Date Recorded: {this.props.data.recording.date}
                  </p>
                }
                { this.props.data && this.props.data.recording.info &&
                  <p>Length: {this.state.video_duration}</p>
                }
              </div>
            </div>
          </div>
          <p className="splashscreen-copyright">
              College of Engineering - University of Michigan
          </p>
        </div>
        <button className="play-btn">Play</button>
      </div>
    );
  }
}

export default SplashScreen;